import { render, staticRenderFns } from "./ResponsibilityAssigmentView.vue?vue&type=template&id=55dfd36b&scoped=true"
import script from "./ResponsibilityAssigmentView.vue?vue&type=script&lang=js"
export * from "./ResponsibilityAssigmentView.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityAssigmentView.vue?vue&type=style&index=0&id=55dfd36b&prod&lang=css"
import style1 from "./ResponsibilityAssigmentView.vue?vue&type=style&index=1&id=55dfd36b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dfd36b",
  null
  
)

export default component.exports